import * as React from "react";

interface ICVPreviewNameProps {
  Name?: string;
  SecondName?: string;
  SubName?: string;
}

const Name = ({ name, secondName }: { name: string; secondName: string }) => {
  return (
    <div className="content-stretch flex items-center justify-center relative shrink-0">
      <div className="font-['Manrope:ExtraBold',sans-serif] font-extrabold leading-[32px] relative shrink-0 text-[#0f172a] text-[32px] whitespace-nowrap">
        <p className="mb-0">{name}</p>
        <p className="font-['Manrope:Regular',sans-serif] font-normal">
          {secondName}
        </p>
      </div>
    </div>
  );
};

const SubName = ({ subName }: { subName: string }) => {
  return (
    <div className="content-stretch flex items-center justify-center relative shrink-0">
      <p className="font-['Manrope:Bold',sans-serif] font-bold leading-[normal] relative shrink-0 text-[#0f172a] text-[12px]">
        {subName}
      </p>
    </div>
  );
};

const CVPreviewNameV2: React.FunctionComponent<ICVPreviewNameProps> = (
  props,
) => {
  return (
    <div className="relative shrink-0 w-full">
      <div className="content-stretch flex flex-col items-start px-[20px] relative w-full">
        <Name name={props.Name || "Name"} secondName={props.SecondName || "SecondName"} />
        <SubName subName={props.SubName || "Software Engineer"} />
      </div>
    </div>
  );
};

export default CVPreviewNameV2;
